<!-- Podcast-Slide For Desktop Start -->
<!-- <ngx-spinner type="ball-scale-multiple" size="medium" [name]="blockLoader"></ngx-spinner> -->

<div class="podcast-slide isPodcastSlideOpen">
    <div class="top-content">
        <div class="left-box">
            Latest Daily D.O.S.E&trade; Podcast
        </div>
        <div class="right-box">
            <mat-icon (click)="setPIPValue('minimize')" style="transform: rotate(90deg);">open_in_new_down</mat-icon>
            <mat-icon (click)="setPIPValue('close')">close</mat-icon>
        </div>
    </div>
    <div class="middle-content">
        <div class="left-box">
            <img [src]="selectedPodcast && selectedPodcast.artwork_url ? selectedPodcast.artwork_url : '../../../../../../assets/images/Podcast-Loader-Img.jpg'" alt="podcast image">
        </div>
        <div class="right-box">
            <div class="top-player-box">
                <div class="play-btn">
                    <mat-icon (click)="onPlayPause()">{{isPlaying ? 'pause' : 'play_arrow'}}</mat-icon>
                </div>
                <div class="date-titile" *ngIf="!isLoadingWavesurfer; else loadingWavesurfer">
                    <div class="date" *ngIf="selectedPodcast && selectedPodcast.formattedPublishingDate">{{ selectedPodcast.formattedPublishingDate }}</div>
                    <!-- <div class="podcast-title">{{ selectedPodcast && selectedPodcast.title ? selectedPodcast.title : "" }}</div> -->
                    <marquee class="podcast-title" *ngIf="selectedPodcast && selectedPodcast.title; else noTitle" style="color: white;" behavior="scroll" direction="left" scrollamount="2">{{selectedPodcast.title}}</marquee>
                    <ng-template #noTitle>
                        <marquee class="podcast-title" behavior="scroll" direction="left" scrollamount="2"></marquee>
                    </ng-template>
                </div>

				<ng-template #loadingWavesurfer>
					<p class="podcast-title">
						Loading podcast audio...
					</p>
				</ng-template>
            </div>
            <div class="middle-player-box">
                <div #mobilewaveform></div>
            </div>
            <div class="bottom-player-box">
                <div class="timeline"><span>{{formatTime(currentTime)}}</span> /{{formatTime(durationTime)}}</div>
                <div class="volume">
                    <mat-icon (click)="toggleMute()">{{isMuted ? 'volume_off' : 'volume_up'}}</mat-icon>
                    <!-- <input type="range" id="volumeRange" min="0" max="100" step="1" value="100" (input)="changeVolume($event.target.value)"> -->
                    <mat-slider *ngIf="!isiPhone"
                        class="custum-pip-slider"
                        [max]="100"
                        [min]="0"
                        [step]="1"
                        [value]="100"
                        (input)="changeVolume($event.value)">
                    </mat-slider>
                </div>
                <div class="action-btn-box" [ngStyle]="{'gap': isiPhone ? '8px' : ''}">
                    <mat-icon (click)="skipBackwardFn()" id="ten">replay_10</mat-icon>
                    <mat-icon (click)="skipForwardFn()" id="ten">forward_10</mat-icon>
                    <mat-icon (click)="toggleIsLiked()" [ngClass]="{'active': isLiked}">favorite</mat-icon>
                    <mat-icon (click)="toggleCommentBox()" [ngClass]="{'active': isComment}">sms</mat-icon>
                </div>
            </div>
        </div>
    </div>
    <div class="bottom-content">
        <button [ngClass]="{'active': isDoseDetailsOpen}" (click)="toggleDoseDetails()">D.O.S.E Details <mat-icon>navigate_next</mat-icon></button>
        <button [ngClass]="{'active': isMoreDetailsOpen}" (click)="toggleMoreDetails()">More D.O.S.E’s <mat-icon>navigate_next</mat-icon></button>
    </div>
</div>
<div [ngClass]="{'isDoseDetailsOpen': isDoseDetailsOpen}" class="more-content dose-details">
    <div class="inner-content">
        <h4 class="details-title">{{ selectedPodcast && selectedPodcast.title ? selectedPodcast.title : "" }}</h4>
        <p class="details-description" [innerHTML]="selectedPodcast && selectedPodcast.description ? selectedPodcast.description : ''">
        </p>
    </div>
</div>
<div [ngClass]="{'isDoseDetailsOpen': isMoreDetailsOpen}" class="more-content more-dose">
    <div class="inner-content">
        <div (click)="urlIndex === i+1 ? onPlayPause() : onUrlChange(i, true)" class="playlist-box" *ngFor="let podcast of podcasts | slice: 1; let i = index">
			<div class="left-box">
				<img [src]="podcast && podcast.artwork_url ? podcast.artwork_url : '../../assets/images/Daily D.O.S.E Podcast TILE_Lemon.png'" alt="Other Podcast Image">
				<div [ngClass]="{'active-dose': urlIndex === i+1}" class="play-btn">
					<mat-icon>{{ urlIndex === i+1 && isPlaying ? 'pause' : 'play_arrow'}}</mat-icon>
				</div>
			</div>
			<div class="right-box">
				<div class="date">{{ podcast.formattedPublishingDate }}</div>
				<div class="play-title">{{ podcast && podcast.title ? podcast.title : "" }}</div>
				<!-- <div class="middle-player-box">
					<div [id]="'waveform'+i"></div>
				</div> -->
                <div class="middle-player-box more-dose-bars">
                    <span *ngFor="let item of customWaveSurfer; let j = index"
                    [style.height.px]="j % 2 === 0 ? (j % 3 === 0 ? '8' : '15') : (j % 4 === 0 ? '22' : '8')"
                          [style.background-color]="(j < customWaveSurfer.length * wavesProgress[i + 1]) ? 'black' : 'gainsboro'"></span>
                </div>
				<div class="timeline">{{ podcast && podcast.duration ? formatTime(podcast.duration) : "" }}</div>
			</div>
		</div>
    </div>
</div>
<div [ngClass]="{'isDoseDetailsOpen': isCommentBoxOpen}" class="more-content comment-box">
    <div class="inner-content" style="position: relative;">
        <div class="comment-head">
            <h4 class="details-title">Write Comments</h4>
            <button (click)="saveComment()">Comment</button>
        </div>
		<textarea [maxLength]="400" (input)="onInputChange($event)" [(ngModel)]="commentBoxText"></textarea>
        <p style="position: absolute;bottom: -5px;right: 25px;font-size: 12px;color: #c6c6c6;">{{commentCharacterCount}}/400</p>
    </div>
</div>
<!-- Podcast-Slide For Desktop End -->